class StoreAvailabilities extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute("variant-id");
    this.available = this.getAttribute("label-available");
    this.unavailable = this.getAttribute("label-unavailable");
  }
  connectedCallback() {
    this.fetchStoreAvailabilities();
  }
  fetchStoreAvailabilities() {
    fetch(`https://us-central1-m-moustache-368916.cloudfunctions.net/getAvailabilities`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: this.variantId })
    }).then((response) => response.json()).then((data) => {
      for (let i = 0; i < data.quantitiesAtLocations.length; i++) {
        this.renderStoreAvailabilities(data.quantitiesAtLocations[i]);
      }
    }).catch((error) => {
      console.error(error);
    });
  }
  renderStoreAvailabilities({ location, available }) {
    console.log(location);
    const template = this.querySelector("#store-availability");
    const storeTemplateElement = template.content.cloneNode(true);
    storeTemplateElement.innerHTML = template.innerHTML;
    storeTemplateElement.querySelector(".js-store-title").textContent = location.name;
    storeTemplateElement.querySelector(".js-store-address").textContent = `${location.address.address1} - ${location.address.zip} ${location.address.city}`;
    storeTemplateElement.querySelector(".js-store-phone").textContent = location.address.phone.replaceAll(",", " ");
    const availabilityClassname = available ? "u-success" : "u-error";
    if (available) {
      storeTemplateElement.querySelector(".icon-stock").style.display = "inline";
      storeTemplateElement.querySelector(".icon-no-stock").style.display = "none";
    } else {
      storeTemplateElement.querySelector(".icon-stock").style.display = "none";
      storeTemplateElement.querySelector(".icon-no-stock").style.display = "inline";
    }
    const availabilityText = available ? this.available : this.unavailable;
    storeTemplateElement.querySelector(".js-store-availability").classList.add(availabilityClassname);
    storeTemplateElement.querySelector(".js-store-availability-text").innerHTML = `${availabilityText}`;
    const openingHours = location.openingHours.value;
    storeTemplateElement.querySelector(".js-store-opening-hours").innerHTML = openingHours.replace(
      /(?:\r\n|\r|\n)/g,
      "<br/>"
    );
    this.appendChild(storeTemplateElement);
  }
}
customElements.define("w3-store-availabilities", StoreAvailabilities);
